module.exports = __webpack_public_path__ + "img/uav-l.c2bb76b5.png";